import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function AssignmentsPage() {
  return <InstituteCrudPage config={entityConfigs['assignments']} />;
}
